import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
// 分享按钮移除，变为看过、已看过发表评论观点
export default {
  name: 'detial-header-buttons',
  props: {
    isCollect: Boolean,
    isSeen: {
      type: Boolean,
      default: false
    },
    isGameProject: Boolean
  },
  created: function created() {
    // 看过按钮曝光打点
    this.statsHandler('collectBtnView');
    this.statsHandler('seeBtnView');
  },
  methods: {
    collect: function collect() {
      this.$emit('onCollect');
    },
    postComment: function postComment() {
      if (this.isSeen) {
        // 已看过曝光打点
        this.statsHandler('seeBtnToDetail');
        this.$emit('toComment');
      } else {
        // 看过曝光打点
        this.statsHandler('seeBtnClick');
        this.$emit('postComment');
      }
    },
    statsHandler: function statsHandler(type) {
      var options = {
        performance_id: this.$route.params.performanceId,
        city_id: Drip.constant.cityId
      };
      var handle = {
        // 看过按钮曝光打点
        seeBtnView: function seeBtnView() {
          window.seedAction({
            bid: 'b_movie_n8f6lkee_mv',
            evt: 'view',
            custom: Object.assign({}, options, {
              custom: Object.assign({}, options)
            })
          });
        },
        // 看过按钮点击打点
        seeBtnClick: function seeBtnClick() {
          window.seedAction({
            bid: 'b_movie_n8f6lkee_mc',
            custom: Object.assign({}, options, {
              custom: Object.assign({}, options)
            })
          });
        },
        // 看过前往评论也打点
        seeBtnToDetail: function seeBtnToDetail() {
          window.seedAction({
            bid: 'b_movie_n8f6lkee_me',
            custom: Object.assign({}, options, {
              custom: Object.assign({}, options)
            })
          });
        },
        collectBtnView: function collectBtnView() {
          window.seedAction({
            bid: 'b_movie_b_ye0v08k2_mv',
            evt: 'view'
          });
        }
      };
      return handle[type]();
    }
  }
};